import { c as _c } from "react/compiler-runtime";
import DropPfp from "@/components/drops/create/utils/DropPfp";
import { useIdentity } from "@/hooks/useIdentity";
import UserFollowBtn, { UserFollowBtnSize } from "@/components/user/utils/UserFollowBtn";
import UserCICTypeIcon from "../user-cic-type/UserCICTypeIcon";
import UserLevel from "../level/UserLevel";
import { CLASSIFICATIONS, CicStatement } from "@/entities/IProfile";
import { useQuery } from "@tanstack/react-query";
import { commonApiFetch } from "@/services/api/common-api";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
import { STATEMENT_GROUP, STATEMENT_TYPE } from "@/helpers/Types";
import { useContext, useEffect, useMemo, useState } from "react";
import { AuthContext } from "@/components/auth/Auth";
import UserStatsRow from "../stats/UserStatsRow";
import { ApiIncomingIdentitySubscriptionsPage } from "@/generated/models/ApiIncomingIdentitySubscriptionsPage";
export default function UserProfileTooltip(t0) {
  const $ = _c(70);
  const {
    user
  } = t0;
  let t1;
  if ($[0] !== user) {
    t1 = {
      handleOrWallet: user,
      initialProfile: null
    };
    $[0] = user;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    profile
  } = useIdentity(t1);
  let t2;
  if ($[2] !== user) {
    t2 = user.toLowerCase();
    $[2] = user;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = [QueryKey.PROFILE_CIC_STATEMENTS, t2];
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== user) {
    t4 = async () => await commonApiFetch({
      endpoint: `profiles/${user}/cic/statements`
    });
    $[6] = user;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = !!user && !!profile?.handle;
  let t6;
  if ($[8] !== t3 || $[9] !== t4 || $[10] !== t5) {
    t6 = {
      queryKey: t3,
      queryFn: t4,
      enabled: t5
    };
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const {
    data: statements
  } = useQuery(t6);
  const t7 = profile?.id;
  let t8;
  if ($[12] !== t7) {
    t8 = [QueryKey.IDENTITY_FOLLOWERS, {
      profile_id: t7,
      page_size: 1
    }];
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== profile?.id) {
    t9 = async () => await commonApiFetch({
      endpoint: `identity-subscriptions/incoming/IDENTITY/${profile?.id}`,
      params: {
        page_size: "1"
      }
    });
    $[14] = profile?.id;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const t10 = !!profile?.id;
  let t11;
  if ($[16] !== t10 || $[17] !== t8 || $[18] !== t9) {
    t11 = {
      queryKey: t8,
      queryFn: t9,
      enabled: t10
    };
    $[16] = t10;
    $[17] = t8;
    $[18] = t9;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  const {
    data: followersData
  } = useQuery(t11);
  const followersCount = followersData?.count ?? 0;
  const [aboutStatement, setAboutStatement] = useState(null);
  let t12;
  let t13;
  if ($[20] !== statements) {
    t12 = () => {
      const about = statements?.find(_temp);
      setAboutStatement(about ?? null);
    };
    t13 = [statements];
    $[20] = statements;
    $[21] = t12;
    $[22] = t13;
  } else {
    t12 = $[21];
    t13 = $[22];
  }
  useEffect(t12, t13);
  const description = profile?.classification ? CLASSIFICATIONS[profile.classification]?.title : null;
  const {
    connectedProfile
  } = useContext(AuthContext);
  const profileHandle = profile?.handle ?? null;
  let t14;
  if ($[23] !== profileHandle) {
    t14 = profileHandle?.toLowerCase() ?? null;
    $[23] = profileHandle;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  const normalizedProfileHandle = t14;
  let t15;
  if ($[25] !== connectedProfile?.handle) {
    t15 = () => connectedProfile?.handle?.toLowerCase() ?? null;
    $[25] = connectedProfile?.handle;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  connectedProfile?.handle;
  let t16;
  if ($[27] !== t15) {
    t16 = t15();
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  const normalizedConnectedHandle = t16;
  const showFollowButton = Boolean(normalizedProfileHandle && normalizedProfileHandle !== normalizedConnectedHandle);
  const t17 = profile?.pfp;
  let t18;
  if ($[29] !== t17) {
    t18 = <div className="tw-flex-shrink-0"><DropPfp pfpUrl={t17} /></div>;
    $[29] = t17;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  const t19 = profile?.handle ?? profile?.display;
  let t20;
  if ($[31] !== t19) {
    t20 = <span className="tw-text-base tw-font-bold tw-text-iron-50 tw-truncate tw-max-w-[180px]">{t19}</span>;
    $[31] = t19;
    $[32] = t20;
  } else {
    t20 = $[32];
  }
  let t21;
  if ($[33] !== profile) {
    t21 = profile && <div className="tw-h-5 tw-w-5"><UserCICTypeIcon cic={profile.cic} /></div>;
    $[33] = profile;
    $[34] = t21;
  } else {
    t21 = $[34];
  }
  let t22;
  if ($[35] !== t20 || $[36] !== t21) {
    t22 = <div className="tw-flex tw-items-center tw-gap-x-2">{t20}{t21}</div>;
    $[35] = t20;
    $[36] = t21;
    $[37] = t22;
  } else {
    t22 = $[37];
  }
  let t23;
  if ($[38] !== description) {
    t23 = description && <p className="tw-text-xs tw-text-iron-400 tw-mb-0">{description}</p>;
    $[38] = description;
    $[39] = t23;
  } else {
    t23 = $[39];
  }
  let t24;
  if ($[40] !== profile) {
    t24 = profile && <div className="tw-mt-1.5"><UserLevel level={profile.level} size="xs" /></div>;
    $[40] = profile;
    $[41] = t24;
  } else {
    t24 = $[41];
  }
  let t25;
  if ($[42] !== t22 || $[43] !== t23 || $[44] !== t24) {
    t25 = <div className="tw-flex tw-flex-col tw-min-w-0">{t22}{t23}{t24}</div>;
    $[42] = t22;
    $[43] = t23;
    $[44] = t24;
    $[45] = t25;
  } else {
    t25 = $[45];
  }
  let t26;
  if ($[46] !== t18 || $[47] !== t25) {
    t26 = <div className="tw-flex tw-gap-x-3 tw-flex-1 tw-min-w-0">{t18}{t25}</div>;
    $[46] = t18;
    $[47] = t25;
    $[48] = t26;
  } else {
    t26 = $[48];
  }
  let t27;
  if ($[49] !== profileHandle || $[50] !== showFollowButton) {
    t27 = showFollowButton && profileHandle && <div className="tw-flex-shrink-0"><UserFollowBtn handle={profileHandle} size={UserFollowBtnSize.SMALL} /></div>;
    $[49] = profileHandle;
    $[50] = showFollowButton;
    $[51] = t27;
  } else {
    t27 = $[51];
  }
  let t28;
  if ($[52] !== t26 || $[53] !== t27) {
    t28 = <div className="tw-flex tw-flex-col tw-gap-y-2"><div className="tw-flex tw-items-start tw-justify-between tw-gap-x-4">{t26}{t27}</div></div>;
    $[52] = t26;
    $[53] = t27;
    $[54] = t28;
  } else {
    t28 = $[54];
  }
  let t29;
  if ($[55] !== aboutStatement) {
    t29 = aboutStatement && <p className="tw-text-sm tw-text-iron-200 tw-line-clamp-6 tw-mb-0 tw-mt-4">{aboutStatement.statement_value}</p>;
    $[55] = aboutStatement;
    $[56] = t29;
  } else {
    t29 = $[56];
  }
  const t30 = profile?.handle ?? user;
  const t31 = profile?.tdh ?? 0;
  const t32 = profile?.tdh_rate ?? 0;
  const t33 = profile?.xtdh ?? 0;
  const t34 = profile?.xtdh_rate ?? 0;
  const t35 = profile?.rep ?? 0;
  const t36 = profile?.cic ?? 0;
  let t37;
  if ($[57] !== followersCount || $[58] !== t30 || $[59] !== t31 || $[60] !== t32 || $[61] !== t33 || $[62] !== t34 || $[63] !== t35 || $[64] !== t36) {
    t37 = <div className="tw-mt-4"><UserStatsRow handle={t30} tdh={t31} tdh_rate={t32} xtdh={t33} xtdh_rate={t34} rep={t35} cic={t36} followersCount={followersCount} /></div>;
    $[57] = followersCount;
    $[58] = t30;
    $[59] = t31;
    $[60] = t32;
    $[61] = t33;
    $[62] = t34;
    $[63] = t35;
    $[64] = t36;
    $[65] = t37;
  } else {
    t37 = $[65];
  }
  let t38;
  if ($[66] !== t28 || $[67] !== t29 || $[68] !== t37) {
    t38 = <div className="tailwind-scope tw-bg-iron-950 tw-min-w-[280px] tw-max-w-[320px]">{t28}{t29}{t37}</div>;
    $[66] = t28;
    $[67] = t29;
    $[68] = t37;
    $[69] = t38;
  } else {
    t38 = $[69];
  }
  return t38;
}
function _temp(statement) {
  return statement.statement_type === STATEMENT_TYPE.BIO && statement.statement_group === STATEMENT_GROUP.GENERAL;
}